import CommonModal from "../../common/CommonModal";
import CustomerCountersTab from "./CustomerCountersTab";

type Props = {
  open: boolean;
  onClose: () => void;
  customerId: number;
  customerName?: string;
  onCustomerUpdated?: () => void | Promise<void>;
};

export default function CustomerProductsModal({
  open,
  onClose,
  customerId,
  customerName,
  onCustomerUpdated,
}: Props) {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title={customerName ? `Produits – ${customerName}` : "Produits"}
      size="xl"
      fitContentHeight
    >
      <CustomerCountersTab customerId={customerId} onCustomerUpdated={onCustomerUpdated} />
    </CommonModal>
  );
}
